export default __webpack_public_path__ + "static/sanjayRakesh4-c9f040d7b2a63216db95378382de365d.jpg";